import script from "./AuthenticatedLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthenticatedLayout.vue?vue&type=script&setup=true&lang=js"

import "./AuthenticatedLayout.vue?vue&type=style&index=0&id=5bb5ad38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bb5ad38"]])

export default __exports__